module.exports = __webpack_public_path__ + "static/media/gryphon-house-lobby.18c035d1.jpeg";